import { render, staticRenderFns } from "./Recapitulatif.vue?vue&type=template&id=c4756f9a&"
import script from "./Recapitulatif.vue?vue&type=script&lang=js&"
export * from "./Recapitulatif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Recapitulatif.vue"
export default component.exports